var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconDisclosureOpen = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 5.151,
  height: 8.888,
  viewBox: "0 0 5.151 8.888",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#348CFD",
  d: "m4.797.354-4.09 4.09 4.09 4.09"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-7.338-5.601h20v20h-20z"
}))));
export { SvgIconDisclosureOpen as ReactComponent };
export default __webpack_public_path__ + "assets/images/icon-disclosure-open.svg";